export default "__VITE_ASSET__DK6HeOtW__"